<template>
    <slot />
</template>

<script>
import {
    normalizeDockZone,
    DOCK_ZONES_LIST,
    TAB_PLACEMENT_BOTTOM,
    TAB_PLACEMENT_TOP,
} from './constants.js';

export default {
    name: 'MultipanelDockTabGroup',

    props: {
        id: { type: String, default: null },
        zone: {
            type: String,
            default: null,
            validator: (v) => {
                if (v == null || v === '') return true;
                return DOCK_ZONES_LIST.includes(String(v).toLowerCase());
            },
        },
        tabPlacement: {
            type: String,
            default: TAB_PLACEMENT_BOTTOM,
            validator: (v) =>
                [TAB_PLACEMENT_BOTTOM, TAB_PLACEMENT_TOP].includes(v),
        },
        dynamic: { type: Boolean, default: false },
        activeTab: { type: String, default: null },
        title: { type: String, default: null },
    },

    emits: ['update:activeTab'],

    inject: {
        multipanelDockLayout: { default: null },
        multipanelDockInheritedZone: { default: null },
        multipanelDockZoneBlockKey: { default: null },
    },

    computed: {
        resolvedZone() {
            if (this.zone != null && this.zone !== '') {
                return normalizeDockZone(this.zone);
            }
            return this.multipanelDockInheritedZone || 'center';
        },
        contentPanelId() {
            const gid = this.id || this._groupKey;
            return `${gid}__content`;
        },
    },

    data() {
        return {
            _groupKey: this.id || `tg-${Math.random().toString(36).slice(2)}`,
        };
    },

    provide() {
        return {
            multipanelDockTabGroupId: this._groupKey,
        };
    },

    mounted() {
        this.$nextTick(() => this.register());
    },

    beforeUnmount() {
        this.multipanelDockLayout?.unregisterTabGroup?.(this._groupKey);
    },

    methods: {
        register() {
            if (!this.multipanelDockLayout?.registerTabGroup) return;

            const panelIds =
                this.multipanelDockLayout.getTabGroupPanelIds?.(
                    this._groupKey,
                ) || [];

            const contentSlot = this.dynamic
                ? this.$slots.content
                : null;

            this.multipanelDockLayout.registerTabGroup(this._groupKey, {
                groupId: this._groupKey,
                zone: this.resolvedZone,
                zoneBlockKey: this.multipanelDockZoneBlockKey,
                tabPlacement: this.tabPlacement,
                dynamic: this.dynamic,
                contentPanelId: this.contentPanelId,
                contentSlot,
                panelIds,
                activePanelId: this.activeTab,
                title: this.title,
            });
        },
    },
};
</script>
